export const DEFAULT_CONFIGURATOR_TYPE = 'shower';


// WEBPACK FOOTER //
// ./src/constants/configuratorType.js